<template>
    <div class="card text-left border-0 shadow product-container-size">
      <div class="card-header text-start">
        <h5><b>USAGE BY PRODUCT</b></h5>
        <button class="btn btn-outline-primary" @click="exportProductsUsage(mutableProducts)">
          Export Product Usage
        </button>
      </div>
      <table class="table table-borderless align-middle">
        <tr class="border-bottom" v-for="item in mutableProducts" :key="item.ID">
          <td v-if="item.ID !== -1 && item.ID !== -2"><h6 class="card-title text-start">{{ item.ProductName }} ({{ item.ID }})</h6></td>
          <td v-if="item.ID !== -1 && item.ID !== -2">
            <button v-on:click="productSwitch(item)" data-bs-toggle="modal" data-bs-target="#productModal" v-if="item.recurring" class="btn bg-transparent"><p class="" v-bind:class="{ 'text-danger': item.ManDaysUsed > (item.ManDaysTotal) }"><b>{{item.ManDaysUsed.toFixed(2)}} / {{item.ManDaysTotal.toFixed(2)}}</b></p></button>
            <button v-on:click="productSwitch(item)" data-bs-toggle="modal" data-bs-target="#productModal" v-else class="btn bg-transparent"><p class="" v-bind:class="{ 'text-danger': item.ManDaysUsed > item.ManDaysTotal }"><b>{{item.ManDaysUsed.toFixed(2)}} / {{item.ManDaysTotal.toFixed(2)}}</b></p></button>
          </td>
        </tr>
        <tr>
          <td><h6 class="card-title text-start">TOTAL</h6></td>
          <td><h6 class="card-title" v-bind:class="{ 'text-danger': totalUsageProducts > totalProducts }">{{totalUsageProducts.toFixed(2)}} / {{totalProducts.toFixed(2)}}</h6></td>
        </tr>
        <tr>
          <td><h6 class="card-title text-start">TIME SPENT</h6></td>
          <td><h6 class="card-title" v-bind:class="{'text-danger': totalTimeSpentOnCampaigns > totalUsageProducts}">{{ totalTimeSpentOnCampaigns.toFixed(2) }} FTE</h6></td>
        </tr>
      </table>
    </div>


    <!-- Modal -->
    <div class="modal fade" id="productModal" tabindex="-1" aria-labelledby="productModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Product information 
              <span v-if="isMutableProductCroDate"> ({{ Object.keys(mutableProductCampaignsId).length}} Campaigns)</span>
              <span v-if="isMutableProductCampaignsId"> ({{ Object.keys(mutableProductCampaignsId).length}} Campaigns)</span>
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div class="modal-body" v-if="mutableProductCroDate">
            <li v-for="item in mutableProductCroDate" :key="item" style="list-style: none;">
              {{dateParse(item)}}
            </li>
          </div>
          <div class="p-3 d-block" v-if="mutableProductCampaignsId">
            <div class="table-responsive">
              <table class="table table-borderless table-hover align-middle">
                <thead>
                  <th scope="col" class="w-auto">Test link</th>
                  <th scope="col" class="w-auto">Usage</th>
                  <th scope="col" class="w-auto">Time Spent</th>
                  <th scope="col" class="w-50">Description</th>
                </thead>
                <tbody>
                  <tr v-for="(value, key) in mutableProductCampaignsId">
                    <th scope="row">
                      <a v-bind:href="'https://app2.abtasty.com/edit/test/'+value.ID+'/main-information'" class="" id:=index dtarget="_blank" v-if="value.TestTypeId === 1">{{ value.ID }}</a>
                      <h6 v-else>{{ value.ID }}</h6>
                    </th>
                    <td v-if="value['ManDaysUsed']!==null && value['ManDaysUsed'] === 0"><h6>( Offered )</h6></td>
                    <td v-else-if="value['ManDaysUsed']!==null && 0.25 <= value['ManDaysUsed'] && value['ManDaysUsed'] <= 1"><h6 class="text-danger">( {{value['ManDaysUsed']}} man-day )</h6></td>
                    <td v-else-if="value['ManDaysUsed']!==null && value['ManDaysUsed'] > 1"><h6 class="text-danger">( {{value['ManDaysUsed']}} man-days )</h6></td>
                    <td v-if="!value['IsTimeSpentOK']"><h6 class="text-danger">{{value['TimeSpentOnCampaign']}} (FTE)</h6></td>
                    <td v-else-if="value['IsTimeSpentOK']"><h6>{{value['TimeSpentOnCampaign']}} (FTE)</h6></td>
                    <td>{{ value['LatestDescription'] }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useClientStore } from '../stores/client';

let props = defineProps({
  products: Array,
  campaignsForProduct: Object,
  totalUsageProducts: Number,
  totalProducts: Number,
  totalTimeSpentOnCampaigns: Number
})

const mutableProductCroDate = ref([])
const mutableProductCampaignsId = ref([])
const isMutableProductCroDate = ref(false)
const isMutableProductCampaignsId = ref(false)

const decimalToHoursAndMinutes = function(decimalTime) {
  if (decimalTime !== undefined && decimalTime !== null) {
    var hour = Math.floor(decimalTime);
    var minute = (decimalTime - hour) * 60;
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (minute < 10) {
      minute = "0" + minute;
    }
    return hour + " : " + minute;
  }
};

const productSwitch = (product) => {
  let productId = product.ID
  if (product.croAcademy) {
    mutableProductCroDate.value = product.Date
    mutableProductCampaignsId.value = null
    isMutableProductCroDate.value = true
    isMutableProductCampaignsId.value = false
  } else {
    mutableProductCampaignsId.value = props.campaignsForProduct[productId]
    if (mutableProductCampaignsId.value === undefined || mutableProductCampaignsId.value === null) {
      mutableProductCampaignsId.value = []
    }
    mutableProductCampaignsId.value.sort((a, b) => {
      return b.id - a.id
    })
    mutableProductCroDate.value = null
    isMutableProductCroDate.value = false
    isMutableProductCampaignsId.value = true
  }
}

const exportProductsUsage = (products) => {
  let csv = convertArrayOfObjectsToCSV(products)
  let todayDateFormatted = new Date().toISOString().slice(0, 10).replace(/-/g, "")
  const clientName = useClientStore().client.Name
  csvExport(csv, 'Product_Usage_' + clientName + '_' +todayDateFormatted)
}

const convertArrayOfObjectsToCSV = (products) => {
  let result, ctr, keys, columnDelimiter, lineDelimiter, data
  columnDelimiter = ','
  lineDelimiter = '\n'
  result = ''
  result += 'ID' + columnDelimiter + 'Product Name' + columnDelimiter + 'Campaign ID' + columnDelimiter + "Test Link" + columnDelimiter + "Usage" + columnDelimiter + "Complexity" + columnDelimiter + "Time Spent" + columnDelimiter + "Description" + lineDelimiter 
  products.forEach((item) => {
    if (item.ID !== -1 && item.ID !== -2) {
      if (props.campaignsForProduct[item.ID] === undefined || props.campaignsForProduct[item.ID] === null) {
        return
      }
      props.campaignsForProduct[item.ID].forEach((campaign) => {
        result += item.ID + columnDelimiter + item.ProductName + columnDelimiter
        result += campaign.id + columnDelimiter
        if (/^\d+$/.test(campaign.id)) {
          result += 'https://app2.abtasty.com/edit/test/' + campaign.id + '/main-information' + columnDelimiter
        } else {
          result += '' + columnDelimiter
        }
        result += campaign['manDaysUsed'] + columnDelimiter
        if (campaign['manDaysUsed'] !== null && campaign['manDaysUsed'] === 0) {
          result += '' + columnDelimiter
        } else if (campaign['manDaysUsed'] !== null && campaign['manDaysUsed'] === 0.25) {
          result += 'duplicated' + columnDelimiter
        } else if (campaign['manDaysUsed'] !== null && campaign['manDaysUsed'] === 0.5) {
          result += 'simple' + columnDelimiter
        } else if (campaign['manDaysUsed'] !== null && campaign['manDaysUsed'] === 1) {
          result += 'medium' + columnDelimiter
        } else if (campaign['manDaysUsed'] !== null && campaign['manDaysUsed'] > 1) {
          result += 'complex' + columnDelimiter
        } else {
          result += '' + columnDelimiter
        }
        if (!campaign['isTimeSpentOK']) {
          result += campaign['timeSpentOnCampaign'] + ' (FTE)' + columnDelimiter
        } else {
          result += campaign['timeSpentOnCampaign'] + ' (FTE)' + columnDelimiter
        }
        result += campaign['latestDescription'] + lineDelimiter
      })
    }
  })
  return result
} 

const csvExport = (csv, filename) => {
  var csvFile
  var downloadLink
  csvFile = new Blob([csv], {type: 'text/csv'})
  downloadLink = document.createElement('a')
  downloadLink.download = filename + '.csv'
  downloadLink.href = window.URL.createObjectURL(csvFile)
  downloadLink.style.display = 'none'
  document.body.appendChild(downloadLink)
  downloadLink.click()
}




</script>


<script>
import { defineComponent } from 'vue'
import dayjs from 'dayjs'
import { onMounted } from 'vue';

export default defineComponent({
  props: ['products','campaignsForProduct'],
  methods: {
    trimMutableProducts () {
      let result = []
      this.products.forEach((product) => {
        if (parseInt(product.id) !== -1 && parseInt(product.id) !== -2) {
          result.push(product)
        }
      })
      return result
    }
  },
  data () {
    return {
      mutableProducts: this.products,
      CampaignsProducts: this.CampaignsProducts,
      campaignsProductsList: [
        '1 campaign per month (recurring)',
        '2 campaigns per month (recurring)',
        '3 campaigns per month (recurring)',
        '4 campaigns per month (recurring)',
        'Quota - 3 campaigns (one-off credit)',
        'Quota - 5 campaigns (one-off credit)',
        'Quota - 10 campaigns (one-off credit)',
        'Analysis pack (5 campaigns)',
        'Migration booster (10 campaigns)',
        'Professional Services - Recurring implementation (1 regular campaign) (OLD)',
        'Professional Services - 5 regular campaigns (One time) (OLD)'
      ],
      creditsProductsList: [
        '1 campaign (2 credits) per month',
        '2 campaigns (4 credits) per month',
        '3 campaigns (6 credits) per month',
        '4 campaigns (8 credits) per month',
        'Quota - 3 campaigns (6 credits)',
        'Quota - 5 campaigns (10 credits)',
        'Quota - 10 campaigns (20 credits)'
      ],
    }
  },
  computed: {
    productsList () {
      return this.trimMutableProducts()
    },
    dateParse (date) {
      return dayjs(date).format('DD-MM-YYYY')
    }
  },
  mounted () {
    this.mutableProducts = this.productsList
  }
})
</script>

<style lang="scss">

.product-container-size {
  width: 100%;
  margin-top: 2vh;
  position: relative;
}
@if $enable-transitions {
  @keyframes progress-bar-stripes {
    0% { background-position-x: $progress-height; }
  }
}
</style>
